<template>
  <div>
    <v-dialog v-model="showModal" :loading="loading" max-width="640px">
      <v-card>
        <v-card-title>
          <span class="headline">{{title}}</span>
          <v-btn style="position: absolute; right: 20px" icon dark @click="hideModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-row>
          <v-col cols="12" style="padding:8px 8px 25px 8px" class="text-center">
            <vimeo-player ref="tutorialplayer"  video-id="416293848" />
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["show", "title"],
  data() {
    return {
      showModal: this.show,
      loading: false,
      notifications: []
    };
  },
  watch: {
    showModal(val) {
      !val && this.$emit("close", false);
    },
    show(val) {
      this.showModal = val;
    }
  },
  methods: {
    hideModal() {
      this.$refs.tutorialplayer.pause();
      this.showModal = false;
      this.$emit("close", false);
    }
  }
};
</script>

<style>
</style>